export enum EOrderTimelineBasis {
  default = 'default',
}
